/**
 * Slim top loading bar - Vastradevi Theme
 * Shows on the current document's own load, and on `pagehide` for any real
 * navigation away (link click, form submit that reloads, back/forward,
 * typed URL). AJAX-only interactions (quickview, cart drawer) never unload
 * the page, so they never trigger it - that's handled by ajax-loader.js.
 */
(function () {
  'use strict';

  var bar = document.getElementById('PageLoadingBar');
  if (!bar) return;

  var pct = 0;
  var growTimer = null;

  function setWidth(p) {
    pct = p;
    bar.style.width = p + '%';
  }

  function start() {
    clearInterval(growTimer);
    bar.classList.add('is-active');
    setWidth(0);
    void bar.offsetWidth; // commit 0% before animating to it
    setWidth(20);
    growTimer = setInterval(function () {
      if (pct < 90) setWidth(pct + (90 - pct) * 0.12);
    }, 200);
  }

  function complete() {
    clearInterval(growTimer);
    setWidth(100);
    setTimeout(function () {
      bar.classList.remove('is-active');
      setTimeout(function () { setWidth(0); }, 300);
    }, 200);
  }

  start();
  if (document.readyState === 'complete') {
    complete();
  } else {
    window.addEventListener('load', complete);
  }

  window.addEventListener('pagehide', start);

  // Restoring from the back/forward cache: the bar can be left mid-animation.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) complete();
  });
})();
